import { ProjectType } from '@symfa-inc/providence-verizon-types';
import { RadioButtonProps } from '@shared/modules/ui-kit/models/interfaces';

export const MOD_NSB_RADIO_BUTTON_GROUP: RadioButtonProps[] = [
  { viewValue: ProjectType.Mod, value: ProjectType.Mod },
  { viewValue: ProjectType.NSB, value: ProjectType.NSB },
];
